/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createForEachTransform } from '../../factoriesAny.js';
export var forEachTransformDependencies = {
  typedDependencies,
  createForEachTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesForEachTransform.generated.js
// module id = 1369
// module chunks = 2